const unexpired = (value, now) => !value || (Number.isFinite(Date.parse(value)) && Date.parse(value) > now);

export const isPOSBatchAvailable = (batch, now = Date.now()) => Number(batch.quantity) > 0
  && !batch.recalled && !batch.removed_from_shelf && unexpired(batch.expiry_date, now);

export const isPOSAvailable = (product, now = Date.now()) => {
  if (!product || !(Number(product.stock_quantity) > 0) || product.recall_locked || product.is_active === false) return false;
  const batches = Array.isArray(product.batches) ? product.batches : [];
  if (!batches.length) return unexpired(product.expiry_date, now);
  return batches.some(batch => isPOSBatchAvailable(batch, now));
};